export class LoadStatus {
    private callback;
    private pending = [];

    public setCallback(callback) {
        this.callback = callback;
    }
    
    public register(namespace: string) {
        this.pending.push(namespace);
    }

    public unregister(namespace: string) {
        this.pending.splice(this.pending.indexOf(namespace), 1);
        if (this.pending.length === 0) {
            this.callback();
        }
    }
}